import React from "react";

const DIR_STYLE = {
  long:    { color: "#22c55e", bg: "rgba(34,197,94,.12)",  border: "rgba(34,197,94,.35)",  label: "🟢 LONG",    kor: "롱" },
  short:   { color: "#ef4444", bg: "rgba(239,68,68,.12)",  border: "rgba(239,68,68,.35)",  label: "🔴 SHORT",   kor: "숏" },
  neutral: { color: "#6b7280", bg: "rgba(107,114,128,.08)", border: "rgba(107,114,128,.2)", label: "⚪ NEUTRAL", kor: "중립" },
};

const GRADE_STYLE = {
  A: { color: "#22c55e", bg: "rgba(34,197,94,.15)" },
  B: { color: "#3b82f6", bg: "rgba(59,130,246,.15)" },
  C: { color: "#f59e0b", bg: "rgba(245,158,11,.15)" },
  D: { color: "#6b7280", bg: "rgba(107,114,128,.12)" },
};

function ConfidenceBar({ confidence, direction }) {
  const color = direction === "long" ? "#22c55e" : direction === "short" ? "#ef4444" : "#6b7280";
  return (
    <div>
      <div style={{ display:"flex", justifyContent:"space-between", fontSize:11, color:"#6b7280", marginBottom:4 }}>
        <span>신뢰도</span>
        <span style={{ color, fontWeight:700 }}>{confidence}%</span>
      </div>
      <div style={{ height:10, background:"#1e2433", borderRadius:5, overflow:"hidden" }}>
        <div style={{
          width: `${confidence}%`, height:"100%",
          background: direction === "long"
            ? "linear-gradient(90deg, #166534, #22c55e)"
            : direction === "short"
            ? "linear-gradient(90deg, #7f1d1d, #ef4444)"
            : "#374151",
          borderRadius:5, transition:"width .6s ease",
        }}/>
      </div>
    </div>
  );
}

export default function SignalPanel({ data }) {
  if (!data) return <p style={{ color:"#6b7280" }}>신호 계산 중...</p>;

  const dir   = data.direction || "neutral";
  const ds    = DIR_STYLE[dir] || DIR_STYLE.neutral;
  const gs    = GRADE_STYLE[data.grade || "D"] || GRADE_STYLE.D;
  const conf  = data.confidence || 0;

  return (
    <div style={{ display:"flex", flexDirection:"column", gap:16 }}>

      {/* 메인 신호 */}
      <div style={{
        display:"flex", alignItems:"center", gap:14,
        padding:"14px 16px", borderRadius:12,
        background: ds.bg, border:`1.5px solid ${ds.border}`,
      }}>
        <div style={{ flex:1 }}>
          <p style={{ fontSize:11, color:"#6b7280", marginBottom:4 }}>종합 포지션 신호</p>
          <p style={{ fontSize:28, fontWeight:800, color:ds.color }}>{ds.label}</p>
        </div>
        <div style={{ textAlign:"center" }}>
          <div style={{
            width:52, height:52, borderRadius:12,
            background: gs.bg, display:"flex", flexDirection:"column",
            alignItems:"center", justifyContent:"center",
          }}>
            <span style={{ fontSize:22, fontWeight:800, color:gs.color }}>{data.grade}</span>
            <span style={{ fontSize:10, color:gs.color }}>등급</span>
          </div>
        </div>
      </div>

      {/* 신뢰도 바 */}
      <ConfidenceBar confidence={conf} direction={dir} />

      {/* 지표별 상세 */}
      <div>
        <p style={{ fontSize:12, color:"#6b7280", marginBottom:8 }}>
          지표 일치: {dir === "long" ? data.long_count : data.short_count}/{data.total_count}개
        </p>
        <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
          {(data.signals || []).map((s, i) => {
            const sdir = s.direction || "neutral";
            const sc   = sdir === "long" ? "#22c55e" : sdir === "short" ? "#ef4444" : "#6b7280";
            const pct  = Math.round(s.strength * 100);
            return (
              <div key={i} style={{
                padding:"8px 12px", borderRadius:8,
                background:"#181c24", border:`1px solid ${sc}22`,
                display:"flex", alignItems:"center", gap:10,
              }}>
                {/* 방향 아이콘 */}
                <span style={{ fontSize:14, flexShrink:0 }}>
                  {sdir === "long" ? "▲" : sdir === "short" ? "▼" : "—"}
                </span>
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ display:"flex", justifyContent:"space-between", marginBottom:3 }}>
                    <span style={{ fontSize:12, fontWeight:700, color:sc }}>{s.label}</span>
                    <span style={{ fontSize:11, color:"#6b7280" }}>강도 {pct}%</span>
                  </div>
                  <p style={{ fontSize:11, color:"#9ca3af", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>
                    {s.detail}
                  </p>
                </div>
                {/* 가중치 */}
                <span style={{
                  fontSize:10, color:"#4b5563",
                  background:"#252a38", padding:"2px 6px", borderRadius:4, flexShrink:0,
                }}>
                  {Math.round(s.weight * 100)}%
                </span>
              </div>
            );
          })}
        </div>
      </div>

      {/* 요약 */}
      <div style={{
        padding:"8px 12px", borderRadius:8,
        background:"#1a1f2e", border:"1px solid #252a38",
        fontSize:12, color:"#9ca3af",
      }}>
        💡 {data.summary}
        <p style={{ fontSize:10, color:"#374151", marginTop:4 }}>
          ※ 자동 계산 신호. 투자 결정은 본인 판단으로.
        </p>
      </div>

      {data.updated_at && (
        <p style={{ fontSize:11, color:"#374151" }}>{data.updated_at}</p>
      )}
    </div>
  );
}
